export default __webpack_public_path__ + "static/media/product_img3.d39ad347.png";